import React from 'react'
import { Route, Switch } from 'react-router-dom'
import NotFound from './pages/notfound/NotFound'
import AuthenticatedRoute from './shared/component/route/AuthenticatedRoute'
import UnauthenticatedRoute from './shared/component/route/UnauthenticatedRoute'
import Routes from './shared/infra/routes/IndexRoutes'

export default ({ childProps }) => (
  <Switch>
    {Routes.map(
      (route, index) =>
        route.isAuthenticated ? (
          <AuthenticatedRoute
            roles={route.roles}
            key={index}
            path={route.path}
            exact
            component={route.component}
            props={childProps}
          />
        ) : (
          <UnauthenticatedRoute
            key={index}
            path={route.path}
            exact
            component={route.component}
            props={childProps}
          />
        )
    )}
    <Route component={NotFound} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/Routes.js